import SelectField from 'components/forms/selectField/SelectField';
import { SelectFieldProps } from 'components/forms/selectField/SelectField.types';
import { AutomatedReviewLogChannel } from 'models/automation/Reviews';
import { useTranslation } from 'react-i18next';

interface ChannelSelectFieldProps
  extends Omit<SelectFieldProps, 'options' | 'optionGroups'> {}

const ChannelSelectField = ({ ...rest }: ChannelSelectFieldProps) => {
  const { t } = useTranslation();

  const options = [
    { label: t('common.all'), value: '' },
    ...Object.values(AutomatedReviewLogChannel).map((value) => ({
      label: t('pageAutomations.reviews.automatedReviewLogs.channels.channel', {
        context: value,
      }),
      value,
    })),
  ];

  return (
    <SelectField colSmInput={8} colSmLabel={4} options={options} {...rest} />
  );
};

export default ChannelSelectField;
